import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectMemberNextDaysRemainDailyFixCredit: "[selectMemberNextDaysRemainDailyFixCredit ] Action",
	selectMemberNextDaysRemainDailyFixCreditLoad:
		"[selectMemberNextDaysRemainDailyFixCreditLoad] Action",
	selectMemberNextDaysRemainDailyFixCreditAsync:
		"[selectMemberNextDaysRemainDailyFixCreditAsync] Action",
};

const initialState = {
	data: [],
	
	loading: false,
};

export const select_member_next_days_remain_daily_fix_credit_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectMemberNextDaysRemainDailyFixCredit:
			return {
				...state,
				data: payload?.data ? payload?.data : [],
			};

		case actionTypes.selectMemberNextDaysRemainDailyFixCreditLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectMemberNextDaysRemainDailyFixCreditLoad,
		payload: true,
	});
	let config = {
		url: "select_request",
	};

	let data = {
		table: "daily_fix_credit",
		method_type: "select_member_next_days_remain",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectMemberNextDaysRemainDailyFixCredit,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({
			type: actionTypes.selectMemberNextDaysRemainDailyFixCreditLoad,
			payload: false,
		});
	}
}

export function* selectMemberNextDaysRemainDailyFixCredit() {
	yield takeEvery(actionTypes.selectMemberNextDaysRemainDailyFixCreditAsync, handleWorker);
}
